import React from 'react';
import { Box, Image, Heading } from '@theme-ui/components';
import BaseComponent from './components/_common/BaseComponent';
import logo from './ESPON-logo.png'

const Sidebar = (props) =>{

return(
    <BaseComponent>
    <Box
    sx={{
        minHeight: '120vh',
        overflow: 'auto',
        width: '430px',
        backgroundColor: 'white',
        position: 'fixed',
        top: 0,
        left: 0
            }}>
            <Image 
            src={logo}
            sx={{
                width: '200px',
                padding: '10px'
            }}
            />
            <Heading sx={{padding: '14px', fontFamily: 'sans-serif'}}>
                ESPON Portal: Data studio
            </Heading>
    </Box>
    
    </BaseComponent>
)
        }
export default Sidebar;